/**
 * 获取支付方式工具类
 *
 * @author terrfly
 * @site https://www.jeepay.vip
 * @date 2021/5/8 07:18
 */

import config from '@/config'

const ALIPAY_LAUNCH_MODE_KEY = 'selectedAlipayLaunchMode'

const getSelectedWayCode = function () {
    return localStorage.getItem('selectedWayCode')
}

const getSelectedAlipayLaunchMode = function () {
    return localStorage.getItem(ALIPAY_LAUNCH_MODE_KEY)
}

const setSelectedAlipayLaunchMode = function (launchMode) {
    if (launchMode === 'app' || launchMode === 'wap') {
        localStorage.setItem(ALIPAY_LAUNCH_MODE_KEY, launchMode)
    } else {
        clearSelectedAlipayLaunchMode()
    }
}

const clearSelectedAlipayLaunchMode = function () {
    localStorage.removeItem(ALIPAY_LAUNCH_MODE_KEY)
}

const getUserAgent = function () {
    return navigator.userAgent || ''
}

const isAlipayClient = function () {
    return getUserAgent().indexOf('AlipayClient') >= 0
}

const isWechatClient = function () {
    return getUserAgent().indexOf('MicroMessenger') >= 0
}

const isMobileBrowser = function () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(getUserAgent())
}

const getRouteNameByWayCode = function (wayCode) {
    if (!wayCode) {
        return null
    }

    if (wayCode.startsWith('WX')) {
        return 'CashierWxpay'
    }

    if (wayCode.startsWith('ALI')) {
        return 'CashierAlipay'
    }

    if (wayCode.startsWith('YSF')) {
        return 'CashierYsfpay'
    }

    return null
}

const buildPayWay = function (wayCode) {
    const routeName = getRouteNameByWayCode(wayCode)
    if (wayCode !== 'ALI_WAP') {
        clearSelectedAlipayLaunchMode()
    }
    return routeName ? { wayCode: wayCode, routeName: routeName } : null
}

const getToPageRouteName = function () {
    const payWay = getPayWay();
    return  payWay? payWay.routeName : null
}

const getPayWay = function () {

    // 优先从localStorage读取用户选择的支付方式
    const selectedWayCode = getSelectedWayCode();
    if (selectedWayCode) {
        return buildPayWay(selectedWayCode);
    }

    if(isWechatClient()){
        clearSelectedAlipayLaunchMode()
        return config.payWay.WXPAY;
    }

    if(isAlipayClient()){
        clearSelectedAlipayLaunchMode()
        return config.payWay.ALIPAY;
    }

    return null;

}

const requiresChannelUserId = function (wayCode) {
    return wayCode === 'WX_JSAPI' || wayCode === 'ALI_JSAPI'
}

export default { getToPageRouteName: getToPageRouteName,
    getPayWay: getPayWay,
    getSelectedWayCode: getSelectedWayCode,
    getSelectedAlipayLaunchMode: getSelectedAlipayLaunchMode,
    setSelectedAlipayLaunchMode: setSelectedAlipayLaunchMode,
    clearSelectedAlipayLaunchMode: clearSelectedAlipayLaunchMode,
    getRouteNameByWayCode: getRouteNameByWayCode,
    isAlipayClient: isAlipayClient,
    isWechatClient: isWechatClient,
    isMobileBrowser: isMobileBrowser,
    requiresChannelUserId: requiresChannelUserId

}
